import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import SearchIcon from '@mui/icons-material/Search';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import './Header.css';

const Header = ({ onSearchClick }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navItems = [
    { label: 'Home', path: '/', exact: true },
    { label: 'Movies', path: '/movies' },
    { label: 'TV Series', path: '/tv-series' },
  ];

  return (
    <motion.header 
      className={`header ${isScrolled ? 'header--scrolled' : ''}`}
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <div className="header__container">
        <div className="header__left">
          <Link to="/" className="header__logo">
            <span className="header__logo-text">NEXTAPE</span>
            <span className="header__logo-accent">STUDIOS</span>
          </Link>
          
          <nav className="header__nav">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`header__nav-link ${
                  (item.exact ? location.pathname === item.path : location.pathname.startsWith(item.path))
                    ? 'header__nav-link--active'
                    : ''
                }`}
              >
                {item.label}
              </Link>
            ))}
          </nav>
        </div>

        <div className="header__actions">
          <button 
            className="header__search-btn"
            onClick={onSearchClick}
            aria-label="Search"
          >
            <SearchIcon />
          </button>
          
          <button 
            className="header__menu-btn"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="Menu"
          >
            {isMobileMenuOpen ? <CloseIcon /> : <MenuIcon />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <motion.div 
        className={`header__mobile-menu ${isMobileMenuOpen ? 'header__mobile-menu--open' : ''}`}
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: isMobileMenuOpen ? 1 : 0, y: isMobileMenuOpen ? 0 : -20 }}
        transition={{ duration: 0.3 }}
      >
        {navItems.map((item) => (
          <Link
            key={item.path}
            to={item.path}
            className="header__mobile-link"
            onClick={() => setIsMobileMenuOpen(false)}
          >
            {item.label}
          </Link>
        ))}
      </motion.div>
    </motion.header>
  );
};

export default Header;